
import { createModel } from './model'


const sort = (asc = true, attr = 'data-filter-time') => {
	return (a, b) => {
		if (a.getAttribute(attr) === b.getAttribute(attr)) return 0
		const order = (a.getAttribute(attr) > b.getAttribute(attr)) ? 1 : -1
		return asc ? order : -order;
	}
}

const show = (items, { time, location }, parent, fragment) => {

	const currentDate = new Date().toISOString().split('T')[0]

	const sortMap = {
		'all' : sort(false),
		'past' : sort(false),
		'future' : sort(true),
		'default' : sort(),
	}
	
	items.sort(sortMap[time] || sortMap['default'])

	items.map(item => {
		const date = item.getAttribute('data-filter-time').split('T')[0]
		const itemLocation = item.getAttribute('data-filter-location')
		const past = (currentDate > date)
		const future = (currentDate <= date)

		const locationMatch = 
			// match all
			!location || 
			// match specific
			(location.trim().toLowerCase() === itemLocation.trim().toLowerCase())

		const timeMatch = 
			(time === 'all') || 
			(time === 'past' && past) ||
			(time === 'future' && future)

		const matched = (timeMatch && locationMatch)

		// add each child in order (sorts visually)
		// put non-matching els into a document fragment
		;(matched ? parent : fragment).appendChild(item)
	})
}

export default () => {

	const list = document.querySelector('.js-events-filter-list')
	const items = [...document.querySelectorAll('.js-events-filter-item')]
	const timeButtons = [...document.querySelectorAll('[data-events-filter-set-time]')]
	const locationSelect = document.querySelector('[data-events-filter-set-location]')
	const frag = document.createDocumentFragment()
	if (!list || !items.length || !timeButtons.length || !locationSelect) return
	
	// model
	const model = createModel()

	// on change

	model.subscribe('time', function(newTime) {
		timeButtons.forEach(button => button.classList.remove('active'))
		const current = timeButtons.filter(button => button.getAttribute('data-events-filter-set-time') === newTime).shift()
		current && current.classList.add('active')
		show(items, model.data(), list, frag)
	})

	model.subscribe('location', newLocation => {
		show(items, model.data(), list, frag)
	})

	// event handlers

	timeButtons.map(button => {
		button.addEventListener('click', e => {
			model.set('time', e.currentTarget.getAttribute('data-events-filter-set-time'))
		})
	})

	locationSelect.addEventListener('change', event => {
		model.set('location', event.currentTarget.value)
	})

	// init

	function setFromDOM() {
		// time
		const button = timeButtons.filter(button => button.classList.contains('active'))
		button.length && model.set('time', button[0].getAttribute('data-events-filter-set-time'))
	}
	setFromDOM()
}